import DocumentsPage from './Documents';

export { DocumentsPage };
export default DocumentsPage;
